import {showMultiboxModal} from '../../LabelConfig/Modals/MultiboxModal/index.js'
import {
  weightSelector,
  isMultiboxSelector,
  updateParcel,
  multiboxShipperTypesSelector,
  isLabelPropertyEnabledSelector,
} from '../../../data/labelInfos/index.js'

import WeightInput from '../../../common/components/Form/WeightInput.js'
import EnableLabelProperty, {PickLabelProperty} from './EnableLabelProperty.js'
import {getState, useSelector} from '../../../store.js'
import useLabelProperty, {
  EMPTY_DEPENDENT_PROPERTIES_FUNC,
  formatMetaClassName,
} from './useLabelProperty.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import ButtonLink from '../../../common/components/Button/ButtonLink.js'
import Weight from '../../../common/components/Weight.js'
import className from '../../../common/className.js'
import ScaleControl from '../../../common/components/Form/ScaleControl.js'
import {showEditWeightDimensionsModal} from '../Modals/EditWeightDimensionsModal.js'
import {SHIPPER_VENDORS} from '../../../common/constants/ShipperNames.js'

const LABEL_PROPERTY = 'packages[0].weight'

export async function handleLabelWeightChange(
  labelInfoID,
  packagesIndex,
  weight,
  onChange,
) {
  updateParcel(labelInfoID, packagesIndex, {weight})

  onChange()
}

export default function SingleWeight({packagesIndex = 0, showTitle}) {
  showTitle = showTitle === false ? false : true

  const {
    labelInfoID,
    shipperType,
    onChange,
    isLabelEnableMode,
    isSummary,
    isPickMode,
  } = useLabelConfigContext()
  const propertySpecs = SingleWeight.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  const weight = useSelector((state) =>
    weightSelector(state, {labelInfoID, packagesIndex}),
  )
  const isMultibox = useSelector((state) =>
    isMultiboxSelector(state, {labelInfoID}),
  )

  useLabelProperty({
    labelProperty,
    propertySpecs,
  })

  const isLabelPropertyEnabled = useSelector((state) =>
    isLabelPropertyEnabledSelector(state, {
      labelInfoID,
      labelProperty,
    }),
  )
  const disabled = isMultibox || (isLabelEnableMode && !isLabelPropertyEnabled)
  const invalidWeight = weight <= 0 && !disabled
  const showSummary = !isLabelEnableMode

  const label = 'Weight'

  if (isSummary) {
    return label
  }

  if (isPickMode && !isLabelPropertyEnabled) {
    return <PickLabelProperty label={label} labelProperty={labelProperty} />
  }

  // We have to "key" the WeightInput to the labelConfigID because, if a user moves quickly between
  // unrelated label config panels, the weight of the previous panel will update the label config of
  // the new order. The WeightInput is watching prop changes and if things settle in the wrong order
  // the new order onChange handler is called with the old weight. Adding a "key" causes a new
  // WeightInput to be created instead of React reusing the old one.
  const weightInput = showSummary ? (
    <div className="wrap--single-weight wrap--weight-summary margin-bottom-15">
      <ButtonLink
        className="darker v-align-base border-underline margin-bottom-7"
        onClick={() =>
          showEditWeightDimensionsModal({
            labelInfoIDs: [labelInfoID],
            packagesIndex,
            focusOn: 'weight',
          })
        }
        disabled={disabled}
      >
        <strong className="fs-02 lh-sm-md">
          <Weight value={weight} />
        </strong>
      </ButtonLink>
      {!disabled && (
        <ScaleControl
          className="margin-left-15"
          onChange={(weight) =>
            handleLabelWeightChange(labelInfoID, 0, weight, onChange)
          }
        />
      )}
    </div>
  ) : (
    <WeightInput
      key={labelInfoID}
      idLb="labelconfigform-weight-lb"
      weightOz={isMultibox ? null : weight}
      setWeightOz={(weight) =>
        handleLabelWeightChange(labelInfoID, 0, weight, onChange)
      }
      metaClassName={formatMetaClassName(labelProperty)}
      allowZero={false}
      showScaleControl
      disabled={disabled}
    />
  )

  if (showTitle) {
    return (
      <li
        className={className`list__item--shipping-options btm-offset-7 meta-labelconfigform-container-weight ${{error: invalidWeight}}`}
      >
        <div className="wrap--edit-preset-form-input inner-wrap--container-weight wrap--md-number-input">
          <div className="flex">
            <label htmlFor="labelconfigform-weight-lb" className="label--bold">
              {label}
            </label>
            {isMultibox && (
              <button
                className="btn btn--link margin-bottom-3 margin-left-3 fs-n0"
                type="button"
                onClick={() => {
                  const [shipperType] = multiboxShipperTypesSelector(
                    getState(),
                    {
                      labelInfoID,
                    },
                  )
                  showMultiboxModal(labelInfoID, shipperType)
                }}
              >
                <em>(Multiple)</em>
              </button>
            )}
          </div>
          {weightInput}
        </div>
        <EnableLabelProperty labelProperty={LABEL_PROPERTY} />
      </li>
    )
  }

  return weightInput
}

SingleWeight.propertySpecList = [
  {
    validShipperTypes: SHIPPER_VENDORS,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: EMPTY_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
  },
]
